import React from "react";
import { ExternalLink, ShieldCheck } from "lucide-react";

/**
 * AFFILIATE-235: On car ad detail pages, when the backend attaches a
 * `carjam_report_url` (car ads with Plate or VIN attribute), render a
 * clear CTA near the vehicle spec rows so buyers can pull the full
 * CarJam history report. Every click is a monetised affiliate click
 * (20% share via `partner=allsale`).
 *
 * Referrer discipline (per kit spec): `rel="noopener"` ONLY — never
 * `noreferrer`. Do NOT wrap in a redirect stripper.
 */
export default function CarJamReportCta({ url, plate }) {
  if (!url) return null;
  return (
    // eslint-disable-next-line react/jsx-no-target-blank -- CarJam affiliate REQUIRES referrer for attribution (20% share). Never noreferrer.
    <a
      href={url}
      target="_blank"
      rel="noopener"
      data-testid="ad-carjam-report-cta"
      className="mt-4 flex items-center gap-3 rounded-2xl bg-white border border-[color:var(--brand-blue-wash)] hover:border-[color:var(--brand-blue)] hover:shadow-card px-4 py-3 transition-all group"
    >
      <div className="w-10 h-10 rounded-xl bg-[color:var(--brand-blue-wash)] text-[color:var(--brand-blue)] grid place-items-center shrink-0">
        <ShieldCheck className="w-5 h-5" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-sm font-bold text-slate-800 leading-tight">
          Check this car&apos;s full history on CarJam
        </div>
        <div className="text-[11px] text-slate-500 mt-0.5">
          Owner records, WoF, RUC, odometer{plate ? ` · plate ${plate}` : ""}
        </div>
      </div>
      <ExternalLink className="w-4 h-4 text-slate-400 group-hover:text-[color:var(--brand-blue)] transition-colors shrink-0" />
    </a>
  );
}
